export default __webpack_public_path__ + "static/media/BookQuest3.0b524fe0.jpg";